import { createBrowserRouter, Navigate } from 'react-router-dom'
import App from './App'
import FastThree from './pages/FastThree'
import Profile from './pages/Profile'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '',
        element: <Navigate to="/fast3" replace />
      },
      {
        path: 'fast3',
        element: <FastThree />
      },
      {
        path: 'profile',
        element: <Profile />
      }
    ]
  }
])